import strFunc from "@/lib/lyg/string";
import StuCardBox from "./card_box";
import CardBoxArea from "@/pages/comp/edu/attend/list_card/area/card_list/area/card_box";
import DateFunc from '@/lib/lyg/date_func';
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";

function StudentCardListArea(props: any) {
  let myProps = {
    room_info: null,
    student_info_arr: [],
    set_student_info_arr: (inData: any) => { },
    now_desku_arr: [],
    now_ymdhis: "",
    pre_date_str: "",
    cardview_sort: "",
    select_desku_seq_arr:[],
    set_select_desku_seq_arr:(inData:any)=>{},
    Style: {},
    show_detail_view: (inData: any) => { },
    open_view_desk_popup: (inData: any) => { },
    openTodoDaySort: (inData: any) => { },
    openTodoWriteOnePopup: (inData: any) => { },
    go_change_todo_state_by_ajax: (inData: any) => { },
    openTodoDailyCWritePopup: (inData: any) => { },
    go_todo_dailyc_write: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let room_info = myProps.room_info;
  let student_info_arr = myProps.student_info_arr;
  let now_desku_arr = myProps.now_desku_arr;
  let now_ymdhis = myProps.now_ymdhis;
  let pre_date_str = myProps.pre_date_str;

  if (myProps.now_ymdhis == "") {
    myProps.now_ymdhis = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
  }
  let now_date_json = DateFunc.get_date_json(new Date(myProps.now_ymdhis));
  let now_sec = now_date_json.date_obj.getTime() / 1000;

  const on_check_desku_change=(inData:any)=>{
    let opt_obj={
      desku_info:{},
      is_check:false,
      ...inData
    };
    let desku_pri_val=opt_obj.desku_info["a_ymd"]+","+opt_obj.desku_info["a_seq"];
    if(opt_obj.is_check){
      let change_select_desku_seq_arr=[...myProps.select_desku_seq_arr];
      if(strFunc.str_in_array(desku_pri_val,change_select_desku_seq_arr)==-1){
        change_select_desku_seq_arr.push(desku_pri_val);
      }
      myProps.set_select_desku_seq_arr(change_select_desku_seq_arr);
    }else{
      let change_select_desku_seq_arr=[];
      for(let i=0;i<myProps.select_desku_seq_arr.length;i++){
        if(desku_pri_val!=myProps.select_desku_seq_arr[i]){
          change_select_desku_seq_arr.push(myProps.select_desku_seq_arr[i]);
        }
      }
      myProps.set_select_desku_seq_arr(change_select_desku_seq_arr);
    }
  };

  const get_now_desk_u_tags = () => {
    //정렬
    now_desku_arr = strFunc.get_sorted_arr_of_key_val_obj({
      arr: now_desku_arr,
      sort: "asc",//asc,desc
      key: "a_name",
      is_number: false,
    });
    let desk_u_tags = now_desku_arr.map((desku_info: any, idx: number) => {
      let stu_info: any = null;
      let desk_info: any = null;

      for (let i = 0; i < student_info_arr.length; i++) {
        if (student_info_arr[i]["a_seq"] == desku_info["a_user_seq"]) {
          stu_info = student_info_arr[i];
          break;
        }
      }
      if (stu_info == null) {
        return "";
      }
      if (room_info.desk_arr) {
        for (let i = 0; i < room_info.desk_arr.length; i++) {
          if (room_info.desk_arr[i]["a_x"] == desku_info["a_x"] && room_info.desk_arr[i]["a_y"] == desku_info["a_y"]) {
            desk_info = room_info.desk_arr[i];
            break;
          }
        }
      }

      let desk_use_time_data=DeskUseDataFunc.get_desk_use_time_data({
        now_ymdhis: myProps.now_ymdhis,
        desku_info: desku_info,
      });
    
      let remain_minute_num = desk_use_time_data.remain_minute_num;
      let elapse_minute_num = desk_use_time_data.elapse_minute_num;
      let time_period = desk_use_time_data.time_period;//21:00 ~ 22:30
      let is_target_time=desk_use_time_data.is_target_time;

      let desk_num_str = "";
      let subject_name="";
      if (desku_info != null) {
        desk_num_str = desku_info["a_name"];
        subject_name=desku_info["a_subject"];
      }

      let desku_pri_val=desku_info["a_ymd"]+","+desku_info["a_seq"];
      let is_select_desku=false;
      if(strFunc.str_in_array(desku_pri_val,myProps.select_desku_seq_arr)!=-1){
        is_select_desku=true;
      }

      let top_sub_text = (
        <span title={time_period}>
          {/* <span>좌석 {desk_num_str}.</span> */}
          <span className="ml-2" onClick={()=>{
            myProps.open_view_desk_popup({
              room_info: room_info,
              desk_info: desk_info,
              desku_info: desku_info,
              now_ymdhis: myProps.now_ymdhis,
            });
          }}>
            <span style={{ color: "#2eb62c" }}>
              {is_target_time ? remain_minute_num : elapse_minute_num}
            </span>
            <span className="ml-1">분{is_target_time?" 남음":" 지남"}</span>
          </span>
          <input type="checkbox" checked={is_select_desku} value="" 
            onChange={(e:any)=>{
              on_check_desku_change({
                desku_info:desku_info,
                is_check:e.target.checked,
              });
            }} style={{position:"absolute",left:5,top:5,width:"15px",height:"15px"}} />
        </span>
      );

      return (
        <div key={idx}>
          {myProps.cardview_sort == "todo" ?
            (<StuCardBox
              key={idx}
              stu_info={stu_info}
              set_stu_info={(inData:any)=>{
                let tmp_stu_info_arr=[...myProps.student_info_arr];
                for(let i=0;i<tmp_stu_info_arr.length;i++){
                  if(tmp_stu_info_arr[i]["a_seq"]==inData.a_seq){
                    tmp_stu_info_arr[i]=inData;
                    break;
                  }
                }
                myProps.set_student_info_arr(tmp_stu_info_arr);
              }}
              subject_name={subject_name}
              desku_info={desku_info}
              desk_info={desk_info}
              room_info={room_info}
              Style={Style}
              now_ymdhis={now_ymdhis}
              pre_date_str={pre_date_str}
              select_desku_seq_arr={myProps.select_desku_seq_arr}
              set_select_desku_seq_arr={myProps.set_select_desku_seq_arr}
              show_detail_user_by_seq={(inData: any) => {
                let tmp_select_stu_info = null;
                for (let i = 0; i < myProps.student_info_arr.length; i++) {
                  if (myProps.student_info_arr[i]["a_seq"] == inData) {
                    tmp_select_stu_info = myProps.student_info_arr[i];
                    break;
                  }
                }
                myProps.show_detail_view({ "stu_info": tmp_select_stu_info });
              }}
              open_view_desk_popup={myProps.open_view_desk_popup}
              openTodoDaySort={myProps.openTodoDaySort}
              openTodoWriteOnePopup={myProps.openTodoWriteOnePopup}
              openTodoDailyCWritePopup={myProps.openTodoDailyCWritePopup}
              go_todo_dailyc_write={myProps.go_todo_dailyc_write}
            ></StuCardBox>) :
            <CardBoxArea
              key={idx}
              user_info={stu_info}
              subject_name={subject_name}
              base_date_str={now_ymdhis.substring(0, 10)}
              pre_date_str={pre_date_str}
              is_view_attend={false}
              is_view_todo_study={true}
              sub_title_text={top_sub_text}
              open_show_detail_view_stu={(inData: any) => {
                myProps.show_detail_view({ "stu_info": inData.user_info });
              }}
              openViewTodoDayPopup={(inData: any) => {
                if (inData.stu_info) {
                  let tmp_todo_open_opt:any={
                    select_stu_name: inData.stu_info.a_user_name,
                    select_stu_seq: inData.stu_info.a_seq,
                  };
                  if(inData.select_date){
                    tmp_todo_open_opt["select_date"]=inData.select_date;
                  }
                  myProps.openTodoDaySort(tmp_todo_open_opt);
                }
              }}
              on_click_sub_title={() => {
                
              }}
              openTodoWriteOnePopup={myProps.openTodoWriteOnePopup}
              go_change_todo_state_by_ajax={myProps.go_change_todo_state_by_ajax}
            ></CardBoxArea>}
        </div>
      );
    });

    if (strFunc.is_empty(desk_u_tags)) {
      desk_u_tags = (
        <div className="text-center" style={{ color: "gray", lineHeight: "40px", width: "100%" }}>
          내용이 없습니다.
        </div>
      );
    }

    return desk_u_tags;
  };

  return (
    <div className={Style.card_list_wrap} style={{ marginTop: "10px" }}>
      {get_now_desk_u_tags()}
    </div>
  );
};
export default StudentCardListArea;